import * as React from 'react';
import PropTypes from 'prop-types';
import colors from '@strava/ui/colors';

const FistBumpWithDashesIconFilled = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.97755 5.12694L8.02246 6.08203L10.0224 8.08201L10.9775 7.12692L8.97755 5.12694Z"
      fill={color}
    />
    <path
      d="M15.0224 5.12697L13.0225 7.12695L13.9776 8.08204L15.9775 6.08206L15.0224 5.12697Z"
      fill={color}
    />
    <path d="M12.6748 4H11.3252V7H12.6748V4Z" fill={color} />
    <path
      d="M0.121094 13.2891L2.66989 19.0239L4.70999 18.0039L2.08279 12.3086L0.121094 13.2891Z"
      fill={color}
    />
    <path
      d="M10.5 10.4298H9.52735L9.51975 10.3995H6.49995V9.39949H9.26965L9.05664 8.54789L6.72075 7.96389C6.58015 7.90479 6.28915 7.80469 5.93755 7.80469C5.26565 7.80469 4.71785 8.15919 4.41415 8.76949L3.04395 11.1677L6.09385 17.7793H8.00005C10.2803 17.7793 10.6436 16.3184 10.6582 16.2559L10.6748 14.8467C10.9902 14.4024 11.1064 13.8491 11.1494 13.4844C11.7637 12.9829 11.9121 12.1822 11.7685 11.5723C11.6064 10.8887 11.0976 10.4297 10.4999 10.4297L10.5 10.4298Z"
      fill={color}
    />
    <path
      d="M19.6034 8.80269C19.2821 8.15909 18.7343 7.80469 18.0624 7.80469C17.7108 7.80469 17.4198 7.90479 17.2792 7.96389L14.9433 8.54789L14.7303 9.39949H17.5V10.3995H14.4802L14.4726 10.4298H13.4999C12.9022 10.4298 12.3935 10.8888 12.2313 11.5724C12.0877 12.1823 12.2362 12.983 12.8504 13.4845C12.8934 13.8492 13.0096 14.4025 13.325 14.8468V16.1046L13.3416 16.256C13.3562 16.3185 13.7195 17.7794 15.9998 17.7794H17.9086L20.9554 11.1673L19.6034 8.80279V8.80269Z"
      fill={color}
    />
    <path
      d="M21.9169 12.3086L19.292 18.0052L21.3302 19.0242L23.879 13.2894L21.9169 12.3086Z"
      fill={color}
    />
  </svg>
);

FistBumpWithDashesIconFilled.defaultProps = {
  color: colors.O50_STRAVA_ORANGE,
  size: 24
};
FistBumpWithDashesIconFilled.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};

export default FistBumpWithDashesIconFilled;
